import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcTraining = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={32}
    height={32}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11 17h10v-2H11zM27 17h2v-2h-2zM3 17h2v-2H3z"
      />
      <path
        stroke="currentColor"
        strokeWidth={1.5}
        d="M21.75 10.75h4.5v10.5h-4.5zM5.75 10.75h4.5v10.5h-4.5z"
      />
    </g>
  </svg>
);
export default SvgIcTraining;
